import CvePage from '@totem/components/software/cves/cvePage';
import PackagePage from '@totem/components/software/software_package/packagePage';
import SoftwareByTagsPage from '@totem/components/software/software_report/byTag/softwareByTagsPage';
import SoftwareByOrganizationPage from '@totem/components/software/software_report/softwareByOrganizationPage';
import SoftwarePage from '@totem/components/software/software_report/softwarePage';
import VulnerabilityReportPage from '@totem/components/software/vulnerabilityReport/vulnerabilityReportPage';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import { securityGroupCheckConstraintAny } from '@totem/components/userContext/security/userUtilities';
import { Route } from '@totem/types/route';
import { UserProfile } from '@totem/types/user';

export const softwareRoutes: Route[] = [
  {
    path: 'software',
    pageTitle: 'Software Catalog',
    component: SoftwarePage,
    exact: true,
    breadcrumbs: [{ label: 'Software Catalog' }],
    render: (userProfile: UserProfile) =>
      permissions.internalSystemAdministrator.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'software/byTag',
    pageTitle: 'Software Catalog',
    component: SoftwareByTagsPage,
    exact: true,
    breadcrumbs: [{ label: 'Software Catalog' }],
    render: (userProfile: UserProfile) =>
      permissions.collaborator.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'software/organization',
    pageTitle: 'Software Catalog',
    component: SoftwareByOrganizationPage,
    exact: true,
    breadcrumbs: [{ label: 'Software Catalog' }],
    render: (userProfile: UserProfile) =>
      permissions.software.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'software/:id',
    pageTitle: 'Software Package',
    component: PackagePage,
    exact: true,
    breadcrumbs: [{ label: 'Software Package' }],
    render: (userProfile: UserProfile) =>
      permissions.collaborator.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'software/cve/:id',
    pageTitle: 'CVE',
    component: CvePage,
    exact: true,
    breadcrumbs: [{ label: 'CVE' }],
    render: (userProfile: UserProfile) =>
      permissions.collaborator.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
  {
    path: 'software/vulnerabilityReport',
    pageTitle: 'Software Vulnerability Report',
    component: VulnerabilityReportPage,
    exact: true,
    breadcrumbs: [{ label: 'Software Vulnerability Report' }],
    render: (userProfile: UserProfile) =>
      permissions.collaborator.hasPermissions(
        userProfile,
        securityGroupCheckConstraintAny,
      ),
  },
];
